import { __rest } from "tslib";
import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import { Input } from '@mui/material';
import { equals } from 'ramda';
import { StyledMenuItem, StyledSelect, StyledSelectLabel, StyledTooltip, } from './select.styles';
export const MAX_ITEM_LENGTH = 14;
const defaultRenderValue = (value) => value;
export const Select = (_a) => {
    var { selected, onChange, options: optionsProp, disableUnderline, renderValue = defaultRenderValue, disabled } = _a, props = __rest(_a, ["selected", "onChange", "options", "disableUnderline", "renderValue", "disabled"]);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        setOptions(extractItems(optionsProp));
    }, [optionsProp]);
    const selectedIndex = useMemo(() => (options.findIndex(({ value }) => equals(value, selected))), [options, selected]);
    const handleChange = useCallback(({ target: { value: index } }) => {
        const numIndex = Number(index);
        const newValue = options[numIndex].value;
        onChange(newValue);
    }, [onChange, options]);
    const renderSelectValue = useCallback((value) => {
        const index = Number(value);
        const option = options[index];
        if (!option)
            return null;
        return renderValue(option.label);
    }, [options, renderValue]);
    const selectValue = selectedIndex >= 0 ? String(selectedIndex) : '';
    return (<StyledSelect variant="standard" onChange={handleChange} value={selectValue} renderValue={renderSelectValue} input={<Input disableUnderline={disableUnderline}/>} disabled={disabled} autoWidth fullWidth={false} MenuProps={{
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            variant: 'menu',
            disableAutoFocusItem: false,
        }} {...props}>
      {options.map(({ label }, index) => {
            const styledLabel = (<StyledSelectLabel>
            {label}
          </StyledSelectLabel>);
            return (<StyledMenuItem value={index} key={label}>
            {label.length > MAX_ITEM_LENGTH ? (<StyledTooltip placement="bottom-start" title={label}>
                {styledLabel}
              </StyledTooltip>) : (styledLabel)}
          </StyledMenuItem>);
        })}
    </StyledSelect>);
};
Select.displayName = 'Select';
export default Select;
export function extractItems(options) {
    return options.map((option) => (typeof option === 'object' ? option : { value: option, label: option }));
}
